exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.ng-invalid.ng-touched{\r\n    border: 2px solid red;\r\n}\r\n\r\n.msg-error{\r\n    color: red;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/twitter/add-twitter/add-twitter.component.css
// module id = ../../../../../src/app/_components/twitter/add-twitter/add-twitter.component.css
// module chunks = main